"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactColor = require("react-color");

var _ColorInput = _interopRequireDefault(require("./ColorInput"));

var _ColorSwatches = _interopRequireDefault(require("./ColorSwatches"));

var _color = _interopRequireDefault(require("react-color/lib/helpers/color"));

var _styles = require("@material-ui/core/styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const useStyles = (0, _styles.makeStyles)(theme => ({
  picker: {
    width: theme.spacing(25),
    display: "flex",
    flexDirection: "column"
  },
  input: {
    fontFamily: "Akkurat Mono, monospace",
    backgroundColor: props => {
      return props.backgroundColor;
    },
    color: props => {
      return props.color;
    },
    minHeight: theme.spacing(14),
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "& input": {
      border: "none",
      backgroundColor: "transparent",
      color: "inherit",
      fontFamily: "inherit",
      fontSize: "inherit",
      lineHeight: "1",
      width: "100%",
      //            minHeight: theme.spacing(7),
      textAlign: "center"
    }
  }
}));

const Colorpicker = ({
  variant = "default",
  hex,
  rgb,
  hsl,
  hsv,
  backgroundColor,
  colors = [],
  onChange
}) => {
  const getContrastColor = () => {
    if (!_color.default.isValidHex(hex)) {
      return false;
    }

    if (hex === 'transparent') {
      return 'rgba(0,0,0,0.4)';
    }

    const yiq = (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
    return yiq >= 128 ? '#000' : '#fff';
  };

  const contrastColor = getContrastColor();
  let color;

  if (variant === "text") {
    backgroundColor = backgroundColor || contrastColor;
    color = hex;
  } else {
    backgroundColor = hex;
    color = contrastColor;
  }

  const classes = useStyles({
    backgroundColor: backgroundColor,
    color: color
  });
  return _react.default.createElement("div", {
    className: classes.picker
  }, _react.default.createElement(_ColorInput.default, {
    className: classes.input,
    variant: variant,
    color: hex,
    onChange: onChange
  }), colors && _react.default.createElement(_ColorSwatches.default, {
    variant: variant,
    backgroundColor: backgroundColor,
    color: hex,
    colors: colors,
    onChange: onChange
  }));
};

var _default = (0, _reactColor.CustomPicker)(Colorpicker);

exports.default = _default;
module.exports = exports.default;